// extracted by mini-css-extract-plugin
export default {"cta":"iG-z","disabled":"jG-z"};